import { connect } from 'react-redux';
import { loadTreatment } from '@surfline/web-common/dist/features/redux';
import EditorialPaywall from './EditorialPaywall';

export default connect(
  null,
  dispatch => ({
    doLoadTreatment: treatment => dispatch(loadTreatment(treatment)),
  }),
)(EditorialPaywall);
